import React from "react";
import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import { IconButton } from "@mui/material";
import trash from "../../Components/assets/Images/trash.svg";
import edit from "../../Components/assets/Images/edit.svg";

interface Props {
  index: number;
  onEditClick: any;
  onDeleteClick: any;
  percentageofShare: number;
  currentIndex: any;
  nominees: any;
}
export default function NomineeBar({
  index,
  onEditClick,
  onDeleteClick,
  percentageofShare,
  currentIndex,
  nominees,
}: Props) {
  // console.log("index", index, "currentIndex", currentIndex);
  return (
    <>
      {nominees.length > 1 ? (
        <div className={Styles.headerTitle}>
          <p className={Styles.nomineeText}>
            {index + 1}
            {index + 1 === 1
              ? "st"
              : index + 1 === 2
              ? "nd"
              : index + 1 === 3
              ? "rd"
              : "th"}{" "}
            Nominee {percentageofShare ? `| ${percentageofShare}%` : ""}
          </p>
          <div>
            <IconButton
              disabled={index === 0}
              style={{
                visibility: index === 0 ? "hidden" : "visible",
              }}
              onClick={() => {
                onDeleteClick();
              }}
              id="nomineesDeleteNomineeButton"
            >
              <img src={trash} style={{ width: "20px" }} />
            </IconButton>
            {index === currentIndex ? (
              ""
            ) : (
              <IconButton
                onClick={() => {
                  onEditClick(index);
                }}
                sx={{ marginLeft: "20px" }}
              >
                <img src={edit} style={{ width: "20px" }} />
              </IconButton>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
